import React, { useState } from 'react';
import './Fade.css';
import SpeedSlider from './SpeedSlider';

const Fade = ({ path1, path2 }) => {
  const [opacity, setOpacity] = useState(0);

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center">
      <div className="fade-images-container" style={{ width: '100%', height: '100%', maxWidth: '550px' }}>
        <img
          src={path1}
          alt="Current view"
          style={{
            width: '100%',
            height: 'auto',
            maxWidth: '550px',
            objectFit: 'contain',
            position: 'absolute',
          }}
        />
        <img
          src={path2}
          alt="Next view"
          style={{
            width: '100%',
            height: 'auto',
            maxWidth: '550px',
            objectFit: 'contain',
            opacity: opacity,
          }}
        />
      </div>
      <div className="slider-for-screen-only">
      <SpeedSlider 
          value={opacity} 
          onChange={setOpacity}
          min={0}
          max={0.99}
          step={0.01}
          label="Opacity"
      />
      </div>
    </div>
  );
};

export default Fade;